import { Icon, IconProps } from "@chakra-ui/react";

export function ThumbUpIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M7 22V11l-4-1v11a1 1 0 0 0 1 1h3Zm0-11 2-7a2 2 0 0 1 2-2h.5a1 1 0 0 1 1 1v3.5a.5.5 0 0 0 .5.5H18a2 2 0 0 1 2 2.24l-1.14 8A2 2 0 0 1 16.87 20H7" />
    </Icon>
  );
}
